module.exports = "textarea {\n    min-height: 200px;\n}\n.admincontent-title-text {\n    font-size: xx-large;\n    margin-bottom: 20px;\n}\n.input-field {\n    font-size: large;\n    color: white;\n}\n/* label color */\n.input-field label {\n    font-size: x-large;\n    color: white;\n}\nbutton {\n    color: white;\n}\nbutton:hover {\n    background-color: #2196f3;\n}\ntextarea{\n    height: 500px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modals/admin/admin-modify-profiles/admin-modify-profiles.component.css
// module id = ./src/app/modals/admin/admin-modify-profiles/admin-modify-profiles.component.css
// module chunks = main